import { getCollectionsUrl, getCollectionUrl, getCreateCollectionUrl, getDeleteCollectionUrl } from "../endpoints/collectionEndpoints";
import { useQuery, useMutation, useQueryClient } from "react-query";
import useAxios from "../../hooks/useAxios";


export const useGetCollection = (code) => {
    const client = useAxios();
    return useQuery(['getCollection', code], () => {
        return client.get(getCollectionUrl(code));
    });
}

export const useGetCollections = () => {
    const client = useAxios();
    return useQuery('getCollections', () => {
        return client.get(getCollectionsUrl());
    });
};

export const useCreateCollection = () => {
    // const queryClient = useQueryClient();
    const client = useAxios();
    return useMutation((collection) => {
        return client.put(getCreateCollectionUrl(), collection);
    }, {
        // onMutate: async(artwork) => {
        //     await queryClient.cancelQueries('getArtworks');
        //     const previousArtworks = queryClient.getQueryData('getArtworks');
        //     queryClient.setQueryData('getArtworks', (prev) => {
        //         return {
        //             ...prev,
        //             data: [...prev.data, artwork]
        //         };
        //     });
        //     return {previousArtworks}; // to revert in case of error
        // },
        // onError: (_error, _artwork, context) => {
        //     queryClient.setQueryData('getArtworks', context.previousArtworks);
        // },
        // onSettled: () => {
        //     queryClient.invalidateQueries('getArtworks');
        // }
    });
};

export const useDeleteCollection = () => {
    const queryClient = useQueryClient();
    const client = useAxios();
    return useMutation((code) => {
        return client.delete(getDeleteCollectionUrl(code));
    }, {
        onMutate: async (code) => {
            await queryClient.cancelQueries('getCollections');
            const previousCollection = queryClient.getQueryData('getCollections');
            queryClient.setQueryData('getCollections', (prev) => {
                return {
                    ...prev,
                    data: [...prev.data].filter((collection) => collection.code !== code)
                };
            });
            return {previousCollection}; // to revert in case of error
        },
        onError: (_error, _collection, context) => {
            queryClient.setQueryData('getCollections', context.previousCollection);
        },
        onSettled: () => {
            queryClient.invalidateQueries('getCollections');
        }
    });
};

export const useAddToCollection = () => {
    return;
};